/* dvk:spec-filters — product-attribute filters (metafields in namespace "specs") on collection pages.
   Added next to the native Search & Discovery filters; filters in place, without new URLs.
   Data and labels come from the section "dvk-spec-data"; cards from "dvk-spec-cards". */
(function () {
  'use strict';

  var root = document.querySelector('[data-collection-root]');
  if (!root || root.getAttribute('data-dvk-specs') !== '1') return;

  var data = null;
  var cards = null;
  var selected = {};
  var saved = null;
  var busy = false;

  function nativeQuery() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    return params.toString();
  }

  function sectionUrl(id) {
    var query = nativeQuery();
    return window.location.pathname + '?' + (query ? query + '&' : '') + 'section_id=' + id;
  }

  function fetchDoc(id) {
    return fetch(sectionUrl(id)).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.text();
    }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function valuesOf(product, key) {
    var value = product.s[key];
    if (value === undefined || value === null || value === '') return [];
    return (Array.isArray(value) ? value : [value]).map(String);
  }

  function matches(product, exceptKey) {
    for (var key in selected) {
      if (key === exceptKey || !selected[key].length) continue;
      var own = valuesOf(product, key);
      if (!selected[key].some(function (value) { return own.indexOf(value) > -1; })) return false;
    }
    return true;
  }

  function display(value, unit) {
    var text = String(value).replace('.', ',');
    if (unit) return text + ' ' + unit;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function sortValues(values) {
    var numeric = values.every(function (value) { return value !== '' && !isNaN(Number(value)); });
    return values.sort(function (a, b) {
      return numeric ? Number(a) - Number(b) : a.localeCompare(b, 'ro', { numeric: true });
    });
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderGroups() {
    var body = root.querySelector('.facets__body');
    if (!body || !data) return;
    var holder = body.querySelector('[data-dvk-spec-groups]');
    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('data-dvk-spec-groups', '');
      body.appendChild(holder);
    }

    var html = '';
    data.config.forEach(function (field, groupIndex) {
      var all = {};
      data.products.forEach(function (product) {
        valuesOf(product, field.key).forEach(function (value) { all[value] = true; });
      });
      var values = sortValues(Object.keys(all));
      if (values.length < 2) return;

      var chosen = selected[field.key] || [];
      html += '<div class="facet-group" data-dvk-group="' + escapeHtml(field.key) + '">' +
        '<div class="mono-label mono-label--filter facet-group__label">' + escapeHtml(field.label) + '</div>' +
        '<div class="facet-group__options">';
      values.forEach(function (value, valueIndex) {
        var count = data.products.filter(function (product) {
          return matches(product, field.key) && valuesOf(product, field.key).indexOf(value) > -1;
        }).length;
        var checked = chosen.indexOf(value) > -1;
        var id = 'DvkFacet-' + groupIndex + '-' + valueIndex;
        html += '<label class="facet' + (count === 0 && !checked ? ' facet--disabled' : '') + '" for="' + id + '">' +
          '<input type="checkbox" id="' + id + '" data-dvk-key="' + escapeHtml(field.key) + '" data-dvk-value="' + escapeHtml(value) + '"' +
          (checked ? ' checked' : '') + (count === 0 && !checked ? ' disabled' : '') + '>' +
          '<span class="facet__name">' + escapeHtml(display(value, field.unit)) + '</span>' +
          '<span class="facet__count">' + count + '</span></label>';
      });
      html += '</div></div>';
    });
    holder.innerHTML = html;
  }

  function anySelected() {
    return Object.keys(selected).some(function (key) { return selected[key].length; });
  }

  function resultMessage(count) {
    return (root.getAttribute('data-results-template') || '').replace('[[count]]', count);
  }

  function applySelection(shouldAnnounce) {
    var container = root.querySelector('#ProductGrid');
    if (!container) return Promise.resolve();
    var grid = container.querySelector('.product-grid, [data-dvk-empty]');
    var pagination = container.querySelector('.pagination, nav[aria-label], [data-pagination]');

    if (!anySelected()) {
      root.setAttribute('data-dvk-spec-active', '0');
      if (saved && grid) {
        grid.replaceWith(saved.grid);
        if (saved.pagination) saved.pagination.style.display = '';
      }
      saved = null;
      if (shouldAnnounce && data) window.Diente.announce(resultMessage(data.products.length));
      return Promise.resolve();
    }

    root.setAttribute('data-dvk-spec-active', '1');

    if (!saved && grid) saved = { grid: grid.cloneNode(true), pagination: pagination };
    var ids = data.products.filter(function (product) { return matches(product); }).map(function (product) { return String(product.id); });

    return (cards ? Promise.resolve(cards) : fetchDoc('dvk-spec-cards').then(function (doc) {
      cards = {};
      doc.querySelectorAll('[data-dvk-card]').forEach(function (node) { cards[node.getAttribute('data-dvk-card')] = node; });
      return cards;
    })).then(function (map) {
      var fresh;
      if (ids.length) {
        fresh = saved.grid.cloneNode(false);
        ids.forEach(function (id) {
          if (!map[id]) return;
          Array.prototype.forEach.call(map[id].children, function (child) { fresh.appendChild(child.cloneNode(true)); });
        });
      } else {
        fresh = document.createElement('div');
        fresh.className = 'empty-state';
        fresh.setAttribute('data-dvk-empty', '');
        fresh.innerHTML = '<p class="empty-state__text">Niciun produs pentru filtrele alese.</p>';
      }
      var current = container.querySelector('.product-grid, [data-dvk-empty]');
      if (current) current.replaceWith(fresh);
      if (saved.pagination) saved.pagination.style.display = 'none';
      document.dispatchEvent(new CustomEvent('wishlist:render'));
      if (shouldAnnounce) window.Diente.announce(resultMessage(ids.length));
    });
  }

  function load() {
    busy = true;
    return fetchDoc('dvk-spec-data').then(function (doc) {
      var node = doc.getElementById('DvkSpecData');
      data = node ? JSON.parse(node.textContent) : null;
      if (!data || data.total > 250) { data = null; return; }
      cards = null;
      saved = null;
      renderGroups();
      if (anySelected()) return applySelection(true);
    }).catch(function () { data = null; }).finally(function () { busy = false; });
  }

  root.addEventListener('change', function (event) {
    var input = event.target.closest('[data-dvk-key]');
    if (!input) return;
    event.stopPropagation();
    var key = input.getAttribute('data-dvk-key');
    var value = input.getAttribute('data-dvk-value');
    var list = selected[key] || (selected[key] = []);
    var at = list.indexOf(value);
    if (input.checked && at === -1) list.push(value);
    if (!input.checked && at > -1) list.splice(at, 1);
    renderGroups();
    applySelection(true);
  }, true);

  /* The native filters replace the facet panel and the product grid; rebuild on top of the new results. */
  new MutationObserver(function () {
    if (busy) return;
    var body = root.querySelector('.facets__body');
    if (body && !body.querySelector('[data-dvk-spec-groups]')) load();
  }).observe(root, { childList: true, subtree: true });

  load();
})();
